import React from "react"
import { Scoped } from "kremling"
import gif from "../../images/Elevate-Security-Animated-Logo.gif"

// CSS
import styles from "../../AdminDashboard.krem.css"

const Loading = () => (
  <div className="row" style={{ height: "65vh" }}>
    <div className="loading-screen-view">
      <img src={gif} alt="Loading..." height="200" width="200" />
    </div>
  </div>
)

export const ScopedLoading = () => (
  <Scoped postcss={styles}>
    <div>
      <Loading />
    </div>
  </Scoped>
)

export default Loading
